import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-zoom-picture-dialog',
    standalone: true,
    imports: [MatDialogModule, MatIconModule],
    templateUrl: './zoom-picture-dialog.component.html',
    styleUrl: './zoom-picture-dialog.component.scss'
})
export class ZoomPictureDialogComponent implements OnInit {

    // Variables for zoom and pan
    zoomVariables = {
        scale: 0.3,
        translateX: 0,
        translateY: 0,
        isPanning: false,
        startX: 0,
        startY: 0,
    };

    zoomDefaults = { ...this.zoomVariables };

    public image: any;
    public images: any[] = [];
    public mobile: boolean = false;
    public showPictureIndex: number = 0;

    get transformStyle(): string {
        return `scale(${this.zoomVariables.scale}) translate(${this.zoomVariables.translateX}px, ${this.zoomVariables.translateY}px)`;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ZoomPictureDialogComponent>) { }

    ngOnInit(): void {
        if (this.data) {
            this.image = this.data.image;
            this.images = this.data.images;
            this.showPictureIndex = this.data.showPictureIndex;
        }
    }

    public selectPicture(index: number) {
        this.showPictureIndex = index;
        // Reset zoom and pan when selecting a new picture
        this.zoomVariables = { ...this.zoomDefaults };
    }

    onWheel(event: WheelEvent) {
        event.preventDefault();
        const delta = event.deltaY > 0 ? -0.1 : 0.1;
        this.zoomVariables.scale = Math.min(Math.max(this.zoomVariables.scale + delta, 0.3), 3);
    }

    startPan(event: MouseEvent) {
        this.zoomVariables.isPanning = true;
        this.zoomVariables.startX = event.clientX;
        this.zoomVariables.startY = event.clientY;
    }

    onPan(event: MouseEvent) {
        if (!this.zoomVariables.isPanning) return;
        const speedFactor = 1.8; // Increase this for faster movement
        const dx = (event.clientX - this.zoomVariables.startX) * speedFactor;
        const dy = (event.clientY - this.zoomVariables.startY) * speedFactor;
        this.zoomVariables.translateX += dx;
        this.zoomVariables.translateY += dy;
        this.zoomVariables.startX = event.clientX;
        this.zoomVariables.startY = event.clientY;
    }

    endPan() {
        this.zoomVariables.isPanning = false;
    }

    closeZoomDialog() {
        this.dialogRef.close(this.showPictureIndex);
    }

}
